<template>
    <img class="loading_style preview_loading" src="@/assets/images/edit/preview/preview_loading.svg" alt="">
</template>

<style lang="less" scoped>
    .preview_loading{
        width: 20px;
        height: 20px;
    }
</style>